









































import { Component, Vue } from 'vue-property-decorator';

import CloseIcon from '@/components/icons/Close.vue';

import eventBus from '@/utils/eventBus';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { Picture } from '@/components/atoms';
import { ETutorial } from '@/models/tutorial';
import BusinessService from '@/api/BusinessService';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseIcon,
    Typography,
    FilledButton,
    Picture
  }
})
export default class CoinNetworkNewsModal extends Vue {
  service = new BusinessService();

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get tPrefix() {
    return 'modals.billing.news';
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  onSubmit() {
    segmentIo.track('Clicked Billing News For You Guided Tour');
    this.onClose();
    eventBus.$emit('startGuidedTour', 'billingGuidedTour');
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  onNotNow() {
    segmentIo.track('Clicked Billing News For You Not Now');
    this.onClose();
  }

  async created() {
    if (!this.business.seenCoinNetworkGuidedTour && !this.isImpersonated)
      await this.service.updateBusinessFlagTutorial({
        state: true,
        flag: ETutorial.SEEN_COIN_NETWORK_GUIDED_TOUR
      });

    segmentIo.modal('Billing News For You');
  }

  destroyed() {
    if (!this.business.seenCoinNetworkGuidedTour)
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.business,
        seenCoinNetworkGuidedTour: true
      });
  }
}
